export class EmissionDesignatorConstants {
    static readonly MINIMUM_EMISSION_DESIGNATOR_LENGTH = 6;
    static readonly MAXIMUM_EMISSION_DESIGNATOR_LENGTH = 10;
}
